import { useCallback } from 'react';
import { useRevertEmailChangeMutation } from 'shared/hooks/queries/use-revert-email-change-mutation';

export const useRevertEmailChange = () => {
  const { mutate, isPending, isSuccess, data, error } =
    useRevertEmailChangeMutation();

  const revertEmailChange = useCallback(
    (token: string, password: string) => mutate({ token, password }),
    [mutate],
  );

  return {
    revertEmailChange,
    isLoading: isPending,
    isSuccess,
    email: data,
    error: error?.kind,
  };
};
